exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".skiptocontent {\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 10; }\n  .skiptocontent:not(:focus) {\n    color: transparent; }\n  .skiptocontent:focus {\n    background-color: #c22032;\n    color: #fff;\n    padding: 0.5rem 1.5rem;\n    outline: thick solid #0095c5;\n    box-shadow: none; }\n", ""])